import { render, staticRenderFns } from "./RequestUserTransactionMessage.vue?vue&type=template&id=afc38bca&scoped=true"
import script from "./RequestUserTransactionMessage.vue?vue&type=script&lang=ts"
export * from "./RequestUserTransactionMessage.vue?vue&type=script&lang=ts"
import style0 from "./RequestUserTransactionMessage.vue?vue&type=style&index=0&id=afc38bca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc38bca",
  null
  
)

export default component.exports